import React from 'react';
import {
  Paper as MuiPaper,
  PaperProps as MuiPaperProps,
  styled
} from '@mui/material';

export interface PaperProps extends MuiPaperProps {
  hasBg?: boolean;
}

/**
 * The background of an application resembles the flat, opaque texture of a sheet of paper, and an application's behavior mimics paper's ability to be re-sized, shuffled, and bound together in multiple sheets.
 *
 * This is a custom wrapper component made of Material-UI Paper.
 *
 * You can read Material-UI Button Documentation [here](https://mui.com/material-ui/api/Paper/).
 *
 * ```typescript
 *  import { Paper } from '@rabex-kit/core';
 *  ```
 *
 *
 * @param props
 * @returns
 */

const Paper: React.FC<PaperProps> = styled(MuiPaper, {
  name: 'MuiPaper',
  shouldForwardProp: prop => !['hasBg'].includes(prop as string)
})<PaperProps>(() => ({}));

Paper.defaultProps = {
  square: false,
  elevation: 1
};

export default Paper;
